import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import { YUPValidations } from "./helper";
import {
  MandatoryStar,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../../Utils/helper";
import {
  activeInactiveDiagnosticsAction,
  addDiagnosticAction,
  getDiagnosticCategoryAction,
} from "../../../../redux/actions/TestPackageCreationAction";
import Modal from "react-modal";

export const AddDiagnosticPopup = ({
  isAddDiagnostic,
  setIsAddDiagnostic,
  searchFilter,
  setSearchFilter,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [isDeactiveDiagnostic, setIsDeactiveDiagnostic] = useState(false);

  useEffect(() => {
    if (isAddDiagnostic?.rowData) {
      setData(isAddDiagnostic?.rowData);
    }
  }, [isAddDiagnostic]);

  const handleClose = async (type) => {
    setIsAddDiagnostic({
      isOpen: false,
      rowData: null,
    });
    setSearchFilter({
      ...searchFilter,
      page: type === "modalClose" ? searchFilter?.page : 1,
    });
    await dispatch(
      getDiagnosticCategoryAction({
        ...searchFilter,
        page: type === "modalClose" ? searchFilter?.page : 1,
      })
    );
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {isAddDiagnostic?.rowData === null
            ? "Add Diagnostic"
            : "Update Diagnostic"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose("modalClose")}
        ></button>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const temp = {
            ...values,
            diagnosticCategoryId:
              isAddDiagnostic?.rowData === null
                ? 0
                : isAddDiagnostic?.rowData?.diagnosticCategoryId,
          };
          const resp = dispatch(addDiagnosticAction(temp));
          resp.then((res) => {
            isLoadingAction(true, dispatch);
            if (res?.data?.status === true) {
              getSnackbarSuccess("success", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
              handleClose("update");
            } else {
              getSnackbarSuccess("error", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
            }
          });
        }}
        validationSchema={YUPValidations}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit } = props;
          return (
            <form
              className="form-admin"
              style={{ overflowX: "hidden" }}
              onSubmit={handleSubmit}
            >
              <div className="modal-body addusermodalbox">
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <label className="col-form-label">
                      Diagnostic Category
                      <MandatoryStar />
                    </label>
                    <input
                      name="diagnosticCategory"
                      type="text"
                      placeholder="Enter Here..."
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.diagnosticCategory}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.diagnosticCategory}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0  mt-4">
                <div></div>
                <div className="d-flex justify-content-end flex-wrap gap-10">
                  {isAddDiagnostic?.rowData !== null && (
                    <a
                      type="button"
                      className={`${
                        data?.isActive === "Y"
                          ? "deactive-button"
                          : "active-button"
                      }`}
                      onClick={() => {
                        setIsDeactiveDiagnostic(true);
                      }}
                    >
                      {data?.isActive === "Y"
                        ? "Deactivate Diagnostic"
                        : "Activate Diagnostic"}
                    </a>
                  )}
                  {(data?.isActive === "Y" ||
                    isAddDiagnostic?.rowData === null) && (
                    <button type="submit" className="savedetails">
                      {isAddDiagnostic?.rowData === null ? "Save" : "Update"}
                    </button>
                  )}
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
      <Modal
        isOpen={isDeactiveDiagnostic}
        className="modal-confirmation-popup"
        overlayClassName="overlay-confirmation-popup  network-z-index"
        ariaHideApp={false}
      >
        <>
          <div className="modal-body modal-body-active-popup popup-text">
            Are you sure you want to
            {data?.isActive === "Y" ? " Deactive" : " Active"} this diagnostic ?
          </div>
          <div className="modal-footer modal-footer-active-popup">
            <button
              type="button"
              className="btn btn-primary"
              style={{ width: "90px" }}
              onClick={async () => {
                await setIsDeactiveDiagnostic(false);
                await dispatch(
                  activeInactiveDiagnosticsAction(
                    data?.diagnosticCategoryId,
                    data?.isActive === "Y" ? false : true
                  )
                );
                handleClose("update");
              }}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-primary btn-logout-no"
              onClick={() => {
                setIsDeactiveDiagnostic(false);
              }}
            >
              No
            </button>
          </div>
        </>
      </Modal>
    </>
  );
};
